module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/png/guests_en-a33b08269b5e110aae8507f02d4ebd91.png";